import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import Popup from './Popup';
import Faq from './Faq';
import Ask from './Ask';
import QuestionList from './QuestionList';
import Replies from './Replies';
import { Route, NavLink } from 'react-router-dom';
import FaqStore from '../stores/FaqStore';
import QuestionStore from '../stores/QuestionStore';
import AskStore from '../stores/AskStore';

@inject('AuthenticationStore')
@observer
export default class Faqs extends Component {
  constructor(props) {
    super(props);

    if (this.props.location.state && this.props.location.state.backUrl)
      this.backUrl = this.props.location.state.backUrl
    else
      this.backUrl = this.props.location.pathname.split('/faqs/')[0];

    const { params } = this.props.match;
    FaqStore.selectSection(params.sectionId);
    AskStore.setSectionId(params.sectionId);
    QuestionStore.setSectionId(params.sectionId);
  }

  _renderMenu() {
    const { AuthenticationStore } = this.props;
		return (
      <ul className="faq-buttons">
        <li><NavLink to={`${this.props.match.url}/faq`} title="FAQ">FAQ</NavLink></li>
      { AuthenticationStore.userCanAnswerQuestions && (
        <li><NavLink to={`${this.props.match.url}/perguntas`} title="Perguntas">Perguntas</NavLink></li>
      )}

      { !AuthenticationStore.userCanAnswerQuestions && (
        <li><NavLink to={`${this.props.match.url}/perguntar`} title="Perguntar">Perguntar</NavLink></li>
      )}

      { !AuthenticationStore.userCanAnswerQuestions && (
        <li><NavLink to={`${this.props.match.url}/respostas`} title="Respostas">Respostas</NavLink></li>
      )}
      </ul>
    );
  }

  render() {
    const { history } = this.props;
    if (FaqStore.selectedSection) {
      return (
        <Popup id="popup-faq"
          onClose={() => history.push(this.backUrl)}
          title={FaqStore.selectedSection.name}
          menu={this._renderMenu()}>
          <Route path={`${this.props.match.url}/faq/:faqId?`} component={Faq}/>
          <Route path={`${this.props.match.url}/perguntar`} component={Ask}/>
          <Route path={`${this.props.match.url}/perguntas/:questionId?`} component={QuestionList}/>
          <Route path={`${this.props.match.url}/respostas/:questionId?`} component={Replies}/>
        </Popup>
      );
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/Faqs.js